import { action } from 'typesafe-actions';
import { ProgressBarSLATypes, PropsSLA } from './types';

export const loadRequest = (protocolo: number) =>
  action(ProgressBarSLATypes.LOAD_REQUEST, { protocolo });

export const loadSuccess = (data: PropsSLA) => action(ProgressBarSLATypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(ProgressBarSLATypes.LOAD_FAILURE);
